import { useIntl } from "react-intl";

import { YesNoModal, YesNoModalProps } from "shared/components/YesNoModal";

export type ItemNotReturnedWarningModalProps = Pick<
  YesNoModalProps,
  "isOpen" | "onClickYes" | "onClickNo"
>;

export function ItemNotReturnedWarningModal({
  onClickYes,
  onClickNo,
  isOpen,
}: ItemNotReturnedWarningModalProps) {
  const intl = useIntl();
  return (
    <YesNoModal
      isOpen={isOpen}
      onClickYes={onClickYes}
      onClickNo={onClickNo}
      title={intl.formatMessage({
        id: "components.item-not-returned-confirmation-modal.title",
      })}
      body={intl.formatMessage({
        id: "components.item-not-returned-confirmation-modal.body",
      })}
      yesLabel={intl.formatMessage({
        id: "generic.actions.delete-item",
      })}
      noLabel={intl.formatMessage({
        id: "generic.actions.cancel",
      })}
      isGrey
    />
  );
}
